import { useIntl } from 'react-intl';
import { Alert, AlertDescription } from 'components/ui/atoms/alert';
import { CheckCircleOutline } from '../icons/CheckCircleOutiline';
import { AlertTypes } from './constants';
import { AlertBannerProps } from './types';

export const AlertBanner = ({
  onClose,
  variant,
  children,
  className = '',
  size = 'default',
}: AlertBannerProps) => {
  const { formatMessage } = useIntl();
  const dismissLabel = formatMessage({
    id: 'checkout.alert.dismiss',
    defaultMessage: 'Dismiss',
    description: 'Dismiss Alert Handler',
  });

  return (
    <Alert
      variant={variant}
      size={size}
      onClose={onClose}
      className={className}
      dismissible
      dismissLabel={dismissLabel}
    >
      {variant === AlertTypes.SUCCESS && size !== 'compact' && (
        <CheckCircleOutline
          svgProps={{ className: 'tw-w-5 tw-h-5 tw-text-[#0D7D4D]' }}
        />
      )}
      <AlertDescription
        className={`tw-flex-1 ${size === 'compact' ? 'tw-text-xs tw-font-normal' : 'tw-font-bold'}`}
      >
        {children}
      </AlertDescription>
    </Alert>
  );
};
